import gql from 'graphql-tag';

export class UserQueries {
  static load = gql`
    query Users {
      users {
        id
        firstName
        lastName
        fullName
        thumbUrl
        team {
          id
          name
        }
        email
      }
    }
  `;

  static me = gql`
    query User {
      me {
        email
        firstName
        lastName
        fullName
        thumbUrl
        id
        title
        mobile
        phone
        nbrDocumentsSent
        registrationCampaign
        signature
        timezone
        language
        team {
          id
        }
        userProfile {
          access {
            dealroomAccess
            contractroomAccess
          }
        }
        bio
        meetingLink
        imageScale
        imageTranslateX
        imageTranslateY
      }
    }
  `;

  static loadUser = gql`
    query LoadUser($userId: String!) {
      user(userId: $userId) {
        id
        firstName
        lastName
        fullName
        title
        mobile
        email
        thumbUrl
        imageScale
        imageTranslateX
        imageTranslateY
      }
    }
  `;

  static getTeam = gql`
    query getTeam {
      me {
        id
        team {
          id
          name
          users {
            id
          }
        }
      }
    }
  `;
}
